import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getData = async (id: string | undefined) => {
  const { data, error } = await supabase
    .from('hashtags_posts')
    .select('post_id')
    .eq('hashtag_id', id)

  if (error) {
    throw new Error(error.message)
  }

  return data?.map((el) => el?.post_id)
}

export default function useGetHashtagPosts(id: string | undefined) {
  return useQuery({
    queryKey: ['useGetHashtagPosts'],
    queryFn: () => getData(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id,
  })
}
